import { render, staticRenderFns } from "./progressDetail.vue?vue&type=template&id=882b544e&scoped=true"
import script from "./progressDetail.vue?vue&type=script&lang=js"
export * from "./progressDetail.vue?vue&type=script&lang=js"
import style0 from "./progressDetail.vue?vue&type=style&index=0&id=882b544e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882b544e",
  null
  
)

export default component.exports